import { memo } from 'react';

import { Heading, TextBlock, VStack } from '@library';
import StoryblokResponsiveImage from '../../../../content/components/PageComponents/StoryblokResponsiveImage';
import type { PostStory } from '../../../../content/types/types';
import LineLimitTextBlock from '../../../../core/components/typography/LineLimitTextBlock';
import CustomLink from '../../../../core/components/CustomLink';
import styles from './PostItem.module.scss';
import PostSubInfo from './PostSubInfo';

const PostItem = ({ post }: { post: PostStory }) => {
    const image = post.content.preview_image?.filename
        ? post.content.preview_image
        : post.content.featured_image;

    return (
        <div className={styles.post}>
            <div className={styles.infoBlock}>
                <VStack gap="small">
                    <CustomLink to={`${post.slug}`}>
                        <div className={styles.header}>
                            <Heading h3>{post.content.title}</Heading>
                        </div>
                    </CustomLink>

                    <TextBlock secondary regular>
                        <div className={styles.summary}>
                            <LineLimitTextBlock
                                text={post.content.summary}
                                lines={3}
                            />
                        </div>
                    </TextBlock>
                    <div className={styles.subInfo}>
                        <PostSubInfo
                            date={post.first_published_at}
                            categoryUUID={post.content.category?.uuid}
                            categoryName={post.content.category?.content?.name}
                        />
                    </div>
                </VStack>
            </div>

            <CustomLink to={`${post.slug}`} className={styles.imageLink}>
                <div className={styles.imageBlock}>
                    <StoryblokResponsiveImage
                        image={image}
                        srcSets={[
                            {
                                width: 310,
                                height: 310,
                                screenWidth: '1x',
                            },
                            {
                                width: 620,
                                height: 620,
                                screenWidth: '2x',
                            },
                        ]}
                        className={styles.image}
                    />
                </div>
            </CustomLink>
        </div>
    );
};

export default memo(PostItem);
